var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-select',{attrs:{"allow-clear":false,"filter-option":false,"label-in-value":true,"options":_vm.options,"show-search":true,"value":_vm.selected},on:{"change":_vm.change,"popupScroll":_vm.popupScroll,"search":_vm.search}})
}
var staticRenderFns = []

export { render, staticRenderFns }